import { render, staticRenderFns } from "./doctorsList.vue?vue&type=template&id=2668ab5d&"
import script from "./doctorsList.vue?vue&type=script&lang=js&"
export * from "./doctorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports